import React, { useEffect } from 'react'
import { scrollToContent } from '../../../utils/layout'

function LifeLongLearningEmbed() {
  useEffect(() => {
    scrollToContent();
  }, [])

  return (
    <div>
        <iframe src={"https://docs.google.com/presentation/d/e/2PACX-1vRzTks3t0i1M2XonU7UXqH3TmTJq_3lKNLj84_8MJVt4fKLOnAB3KRTvh7TFyHKjmLb2tRAwprnldBj/embed?start=false&loop=false&delayms=3000"} style={{width:'100%', height:window.innerHeight}} frameborder="0"></iframe>
    </div>
  )
}

export default LifeLongLearningEmbed